module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("8SnyY"))).then(() => parcelRequire('ljYL6'));